import { useAuthStore, useMemberStore } from "@/stores";
import { isWeChat } from "@/utils/browser";
import { authorizeWxCode } from "@/utils/Wechart";

const navigateToLogin = (params: string = '') => {
    // #ifdef H5
    if (isWeChat()) {
        authorizeWxCode(
            `${window.location.origin}/pages/login/login`,
            params
        );
        return;
    }
    // #endif
    uni.navigateTo({ url: `/pages/login/login${params ? `?state=${params}` : ''}` })
}

export const switchTab = (url: string = '/') => {
    uni.switchTab({
        url: url, fail: () => {
            uni.navigateTo({ url: url })
        }
    })
}

export const loginSuccess = async ({ token, url }: { token: string, url?: string | null }) => {
    await useAuthStore().setToken(token)
    await useMemberStore().setUserLevel()
    // 成功提示
    uni.showToast({ icon: 'success', title: '登录成功' })

    url && switchTab(url)
}



export const tokenError = () => {
    if (useMemberStore()?.userLevel?.sourceType === 'CMCC') {
        uni.showToast({
            icon: 'none',
            title: '页面已超时，请重新进入',
        })
    } else {
        uni.showToast({
            icon: 'none',
            title: '页面已超时',
        })

        if (uni.getStorageSync('tt')) {
            uni.navigateTo({ url: `/pages/sys/error` })
        } else {

            let paramUrl = ''
            let jump = true

            // #ifdef H5
            jump = window.location.href.indexOf('/pages/login/login') < 0
            paramUrl = window.location.href
                .replace(window.location.origin, '')
            // #endif

            paramUrl = paramUrl === '/' ? '' : paramUrl
            if (jump) {
                // console.log(paramUrl)
                navigateToLogin(paramUrl)
            }
        }
    }
}